module.exports = __webpack_public_path__ + "605230a66886935dd77ce6796743789f.jpg";